import { jsx as _jsx } from "react/jsx-runtime";
import { getWidgetDefinitions, PartnerIntegrationsSettings, } from '@dixa/lib-integrations-partner-widgets';
import { Page } from '@dixa/lib-shared-habla';
import { client as elevioClient } from 'elevio';
import { config } from 'lib-shared-backend-config';
import { useNavigate } from 'react-router-dom';
import { articles } from 'utils/elevio';
import { useAppPathParams } from 'utils/url/useAppPathParams';
import { SettingsIntegrationsDocumentationButton } from '../../components/documentationButton/documentationButton';
import { PartnerIntegrationsWidgetError } from './components/error';
import { capitalizeFirstLetter, integrationsBaseRoute, } from './partnerIntegrationsWidget.utils';
import { usePartnerIntegrationNotification } from './utils';
const widgetDefinitions = getWidgetDefinitions();
/**
 * The page where a partner integration widget configuration can be updated or
 * deleted. The form data, queries, mutations and validation is taking place in
 * `PartnerIntegrationsSettings`.
 */
export const PartnerIntegrationsWidgetView = () => {
    const navigate = useNavigate();
    const { id, type } = useAppPathParams('/settings/integrations/partner-widget/:type/:id');
    const showNotification = usePartnerIntegrationNotification();
    const integrationType = type === null || type === void 0 ? void 0 : type.toUpperCase();
    const isValidWidgetType = integrationType in widgetDefinitions;
    const title = isValidWidgetType && type
        ? `${capitalizeFirstLetter(type)} widget settings`
        : 'Widget settings';
    return (_jsx(Page.Section, Object.assign({ title: title, titleMeta: type in articles.settings.partners.widget && (_jsx(SettingsIntegrationsDocumentationButton, { onClick: () => elevioClient.openArticle(articles.settings.partners.widget[type]) })) }, { children: id && isValidWidgetType ? (_jsx(PartnerIntegrationsSettings, { configuration: {
                baseUrl: config.url.partnerIntegrations,
            }, integrationId: id, type: integrationType, handleRedirect: () => navigate(integrationsBaseRoute, { replace: true }), showNotification: showNotification })) : (_jsx(PartnerIntegrationsWidgetError, {})) })));
};
